import React, { useRef } from "react";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import DashboardWidget from "../../widgets/ContainerWidget/DashboardWidget";
import DashboardWidgetBody from "../../widgets/ContainerWidget/DashboardWidgetBody";
import TipTapEditor from "../../common/TipTapEditor";

const useStyles = makeStyles(theme => ({
  content: {
    cursor: props => props.cursor,
  },
  textEditor: {
    top: 0,
    position: "absolute",
    left: 0,
    right: 0,
    zIndex: 1,
  },
  htmlContent: {
    textShadow: props => props.textShadow,
  },
  configure: {},
}));

const createCustomStyles = props => ({
  cursor: props.allowEditing ? "pointer" : "inherit",
  textShadow: `${props.textShadowH}px ${props.textShadowV}px ${props.textShadowBlur}px ${props.textShadowColor}`,
});

const rgbColorOrDefault = (color, defaultColor) =>
  typeof color === "object" && "r" in color
    ? `rgb(${color.r || 0} ${color.g || 0} ${color.b || 0} / ${color.a || 1})`
    : defaultColor;

const getStyleProps = ({ allowEditing, layout }) => {
  const { textShadowBlur, textShadowColor, textShadowH, textShadowV } = layout || {};
  return {
    allowEditing,
    textShadowBlur: textShadowBlur || 0,
    textShadowColor: rgbColorOrDefault(textShadowColor, "transparent"),
    textShadowH: textShadowH || 0,
    textShadowV: textShadowV || 0,
  };
};

const TextEditor = ({
  canEditDashboard,
  index,
  isEditing,
  layout,
  onEdit,
  onCancel,
  onUpdate,
  overflowEditor,
  showEditor,
  textContent,
}) => {

  const allowEditing = canEditDashboard && isEditing;
  const styleProps = getStyleProps({ allowEditing, layout });
  const customStyles = createCustomStyles(styleProps);
  const classes = useStyles(customStyles);

  const editorRef = useRef(null);

  const handleCancel = () => {
    onCancel();
  };

  const handleEditTextContent = () => {
    if (allowEditing) {
      onEdit(index);
    }
  };

  return (
    <DashboardWidget>
      <DashboardWidgetBody>
        <Box
          className={clsx([
            classes.content,
            showEditor && overflowEditor && classes.textEditor,
          ])}
          onClick={allowEditing && !showEditor ? handleEditTextContent : undefined}
        >
          {showEditor && (
            <>
              <TipTapEditor
                ref={editorRef}
                defaultValue={textContent}
                editable={allowEditing}
                toolBarVisible
                minHeight={100}
              />
              <Button onClick={() => onUpdate(index, editorRef.current.getHTML())}>Spara</Button>
              <Button onClick={handleCancel}>Avbryt</Button>
            </>
          )}

          {!showEditor && textContent && (
            <div
              className={classes.htmlContent}
              dangerouslySetInnerHTML={{ __html: textContent }}
            />
          )}
        </Box>
      </DashboardWidgetBody>
    </DashboardWidget>
  );
};

export default TextEditor;
